import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  Tooltip,
  message,
} from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import {
  fetchBlosterDropdown,
  resetBlosterList,
  resetCurrentBlosterPage,
} from '../../slices/bolster';
import {
  fetchDiePressDropdown,
  resetCurrentDiePressPage,
  resetDiePressList,
} from '../../slices/die-press';
import {
  fetchVendorDropdown,
  resetCurrentVendorPage,
  resetVendorList,
} from '../../slices/vendor';
import {
  fetchDieProfileDropdown,
  resetDieProfileData,
  resetDieProfileList,
} from './../../slices/die-profile';
import {
  fetchDieSizeList,
  fetchDieSizeDropdown,
  resetCurrentDieSizePage,
  resetDieSizeList,
} from './../../slices/die-size';
import { createTransporter } from './../../slices/transporter';
import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
import { debounce } from 'lodash';
const { Option } = Select;

function AddTransporter() {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [searchDieSize, setSearchDieSize] = useState('');
  const [searchDeveloper, setSearchDeveloper] = useState('');
  const [searchDiePress, setSearchDiePress] = useState('');
  const [searchGroup, setSearchGroup] = useState('');
  const [searchBloster, setSearchBloster] = useState('');
  const dispatch = useDispatch();
  const [runUnderDeviation, setRunUnderDeviation] = useState('under development');
  const [runUnderDeviationReason, setRunUnderDeviationReason] = useState('');
  const {
    list: dieProfileDropdown,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);

  const {
    list: dieSizeList,
    loading: dieSizeLoading,
    currentPage: dieSizeCurrentPage,
    hasMore: dieSizeHasMore,
  } = useSelector(state => state.diesize);
  const {
    list: developerList,
    loading: developerLoading,
    currentPage: developerCurrentPage,
    hasMore: developerHasMore,
  } = useSelector(state => state.vendor);
  const {
    list: blosterList,
    loading: blosterLoading,
    currentPage: blosterCurrentPage,
    hasMore: blosterHasMore,
  } = useSelector(state => state.bloster);
  const {
    list: diePressList,
    loading: diePressLoading,
    currentpage: diePressCurrentPage,
    hasMore: diePressHasMore,
  } = useSelector(state => state.diePress);
  const [isReceivedDateRequired, setIsReceivedDateRequired] = useState(false);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(false);
  const [isCheckboxDisabledActive, setIsCheckboxDisabledActive] = useState(false);
  const [selectedSolidOption, setSelectedSolidOption] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [dieType, setDieType] = useState(null);
  const [selectSendSmsType, setSelectSendSmsTypeOption] = useState(null);
  const [selectIsActiveOption, setSelectIsActiveOption] = useState(null);
  const [selectSemiHollowOption, setSelectSemiHollowOption] = useState(null);
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [showInitialLoader, setShowInitialLoader] = useState(false);
  const [showDropdownLoader, setShowDropdownLoader] = useState(false);
  const [forceOpen, setForceOpen] = useState(false);

  const sendingSmsType = [
    { id: 'sms', name: 'sms' },
    { id: 'whatsapp', name: 'whatsapp' },
    { id: 'email', name: 'email' },
  ];
  const isActiveStatus = [
    { id: 'active', name: 'active' },
    { id: 'inactive', name: 'inactive' },
   
  ];

  const balanceType = [
    { id: 'debit', name: 'debit' },
    { id: 'credit', name: 'credit' },
    
  ];



  const handleSolidOptionChange = value => {
    setSelectedSolidOption(value);

    form.setFieldsValue({
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };
  const handleSearchSolidDie = value => {
    setSelectedSolidOption(value);
  };
  const handleDeviationChange = e => {
    const value = e.target.value;
    setRunUnderDeviation(value);
    if (value !== 'inactive') {
      setRunUnderDeviationReason('');
    }
    // If "Active" is selected, make received_date required
    if (value === 'active') {
      setIsReceivedDateRequired(true);
    } else {
      setIsReceivedDateRequired(false);
      // If moving away from Active, clear received_date
      if (form.getFieldValue('received_date')) {
        form.setFieldsValue({ received_date: null });
      }
    }
    // If "Active" is selected and no received_date, optionally focus the field (UX improvement)
    if (value === 'active' && !form.getFieldValue('received_date')) {
      // Optionally focus the field
    }
  }
  const handleSendSmsTypeOptionChange = value => {
    if(value){
    setSelectSendSmsTypeOption(value);
    }else{
      setSelectSendSmsTypeOption(null);
    }
   
  };
  const handleIsActiveOptionChange = value => {
    if(value){
    setSelectIsActiveOption(value);
    }else{
      setSelectIsActiveOption(null);
    }
   
  };


  const handleSearchSmsTypeDie = value => {
    setSelectSendSmsTypeOption(value);
  };
  const handleSearchIsActive = value => {
    setSelectIsActiveOption(value);
  };

  const handleReasonChange = e => {
    setRunUnderDeviationReason(e.target.value);
  };

  const handleReceivedDateChange = (date, dateString) => {
    form.setFieldsValue({ received_date: date });
    if (date) {
      setRunUnderDeviation('active');
      setIsReceivedDateRequired(true);
      form.setFieldsValue({ run_under_deviation: 'active', is_active: true });
    } else {
      setRunUnderDeviation('under development');
      setIsReceivedDateRequired(false);
      form.setFieldsValue({ run_under_deviation: 'under development', is_active: false });
    }
  };
  const handleFormChange = changedValues => {
    // Only keep logic for other fields if needed, received_date and run_under_deviation are handled above
    // (No-op for these fields)
  };

  const handleCityChange = (selected, value) => {
    setSelectedCity(value);
 
   
  };
  const debouncedSearchDieProfile = debounce((value, dispatch) => {
    dispatch(resetDieProfileData()); // Reset the list when searching
    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 50,
        search: value || '',
      }),
    );
  }, 300);
  const handleSearchCity = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const onScrollCity = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;

      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };

  const onScrollDiePress = async event => {
    const target = event.target;
    if (
      !diePressLoading &&
      diePressHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchDiePressDropdown({ page: diePressCurrentPage, pagesize: 10 }),
      );
    }
  };

  const handleSearchDieSize = value => {
    setSearchDieSize(value);
    if (value) {
      setSearchDieSize(value);
      dispatch(resetDieSizeList());
      dispatch(fetchDieSizeDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchDieSize('');
      dispatch(resetDieSizeList());
      dispatch(resetCurrentDieSizePage());
      dispatch(fetchDieSizeDropdown({ page: 1, pagesize: 100, search: value }));
    }
  };
  const handleChangeDieSize = value => {
    setSearchDieSize(value);
  };

  const handleSearchDeveloper = value => {
    setSearchDeveloper(value);
    if (value) {
      setSearchDeveloper(value);
      dispatch(resetVendorList());
      dispatch(fetchVendorDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchDeveloper('');
      dispatch(resetVendorList());
      dispatch(resetCurrentVendorPage());
      dispatch(fetchVendorDropdown({ page: 1, pagesize: 10 }));
    }
  };

  const handleChangeDeveloper = value => {
    setSearchDeveloper(value);
  };

  const handleSearchBloster = value => {
    setSearchBloster(value);
    if (value) {
      setSearchBloster(value);
      dispatch(resetBlosterList());
      dispatch(fetchBlosterDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchBloster('');
      dispatch(resetBlosterList());
      dispatch(resetCurrentBlosterPage());
      dispatch(fetchBlosterDropdown({ page: 1, pagesize: 10 }));
    }
  };
  const handleChangeBloster = value => {
    setSearchBloster(value);
  };

  const onScrollDieSize = async event => {
    const target = event.target;
    if (
      !dieSizeLoading &&
      dieSizeHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchDieSizeDropdown({ page: dieSizeCurrentPage, pagesize: 10 }));
    }
  };

  const onScrollDeveloper = async event => {
    const target = event.target;
    if (
      !developerLoading &&
      developerHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchVendorDropdown({ page: developerCurrentPage, pagesize: 10 }));
    }
  };

  const onScrollBloster = async event => {
    const target = event.target;
    if (
      !blosterLoading &&
      blosterHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchBlosterDropdown({ page: blosterCurrentPage, pagesize: 10 }));
    }
  };
  const handleSearchDiePress = value => {
    setSearchDiePress(value);
    if (value) {
      setSearchDiePress(value);
      dispatch(resetDiePressList());
      dispatch(fetchDiePressDropdown({ page: 1, pagesize: 10, search: value }));
    } else {
      setSearchDiePress('');
      dispatch(resetDiePressList());
      dispatch(resetCurrentDiePressPage());
      dispatch(fetchDiePressDropdown({ page: 1, pagesize: 10 }));
    }
  };
  const handleChangeDiePress = value => {
    setSearchDiePress(value);
  };

  useEffect(() => {
    dispatch(resetDieProfileList());
    dispatch(resetDieSizeList());
    dispatch(resetDiePressList());
    dispatch(resetVendorList());
    dispatch(resetBlosterList());
    dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 1000 }));
    // dispatch(fetchDieSizeList({ page: 1, pagesize: 1000 }));
    dispatch(fetchDieSizeDropdown({ page: 1, pagesize: 100 }));
    dispatch(fetchVendorDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchBlosterDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchDiePressDropdown({ page: 1, pagesize: 1000 }));
  }, [dieType]);

  const handleFinish = values => {
    setBtnLoading(true);
    const formattedValues = {
      ...values,

 
    };
    values = formattedValues;
    // values.deleted = 0;
    dispatch(createTransporter({ values }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        if (result.success) {
          message.success('Transporter Created Successfully!');
          navigate('/transporter-list');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const handleFieldChange = () => {
    const rackNo = form.getFieldValue('rac_no') || '';
    const rowNo = form.getFieldValue('row_no') || '';
    const columnNo = form.getFieldValue('column_no') || '';

    const dieLocation = `${rackNo} / ${rowNo} / ${columnNo}`;

    form.setFieldsValue({ die_location: dieLocation });
  };
  return (
    <>
      <div className="sticyaction">
        <Row
          className="pagenamerow mb-0"
          justify="space-between"
          align="middle"
        >
          <Col>
            <h2 style={{ margin: 0 }}>Add Transporter</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/transporter-list">Transporter List</Link> },
                  { title: 'Add Transporter' },
                ]}
              />
            </div>
          </Col>
        </Row>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          onValuesChange={handleFormChange}
          form={form}
          initialValues={{
            is_active: true,
         
          }}
          onFinish={handleFinish}
          autoComplete="off"
        >
          <div className="formsection">
            <Row gutter={16}>
            <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Party Name"
                  name="party_name"
                  rules={[
                    { required: true, message: 'Please enter party name' },
                  ]}
                >
                  <Input placeholder="Enter Party Name"  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Party Code"
                  name="party_code"
                  rules={[
                    { required: true, message: 'Please enter party code' },
                  ]}
                >
                  <Input placeholder="Enter Party Code"  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Opening Balance"
                  name="opening_balance"
                  rules={[
                    { required: true, message: 'Please enter opening balance' },
                    // {
                    //   pattern: /^\d*\.?\d*$/,
                    //   message: 'Please enter only digits & decimal.',
                    // },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input placeholder="Opening Balance" maxLength={15} />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="balance_type"
                    label="Balance Type"
                    rules={[
                      {
                        required: true,
                        message: 'Please select a balance type',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Balance Type"
                      onChange={handleSolidOptionChange}
                      onSearch={handleSearchSolidDie}
                      showSearch={true}
                      value={selectedSolidOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          balanceType.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
                   
              <Col xs={24} sm={12} xl={6} xxl={4}>
                <Form.Item
                  label=""
                  name="is_cash_amount"
                  valuePropName="checked"
                >
                  <Checkbox >Is This Cash Account</Checkbox>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={6} xxl={6}>
              <Form.Item label="Address" name="address">
            <Input.TextArea
              rows={3}
              placeholder="Enter Address"
              maxLength={100}
              onChange={e => {
                const value = e.target.value;
                const formattedValue = value
                  .toLowerCase()
                  .replace(/\b\w/g, char => char.toUpperCase());
                form.setFieldsValue({ address: formattedValue }); // Update Form state
              }}
            />
          </Form.Item>
          </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
              
              <Form.Item
                  label="City"
                  name="city"
                  rules={[
                    { required: true, message: 'Please enter city' },
                  ]}
                >
                  <Input placeholder="Enter City"  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Pincode"
                  name="pincode"
                  rules={[
                    { required: true, message: 'Please enter pincode' },
                    {
                        pattern: /^[0-9]{6}$/,
                        message: 'Pincode must be exactly 6 digits',
                      },
                  ]}
                >
                  <Input placeholder="Enter Pincode"  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
              <Form.Item
                    label="Mobile Number (SMS)"
                    name="mobile_no_sms"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your phone number!',
                      },
                    ]}
                  >
                    <PhoneInput
                      country={'in'} // Default country (India)
                      enableSearch={true} // Enable searching for countries
                      placeholder="Enter mobile number"
                    />
                  </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
              <Form.Item
                    label="Mobile Number"
                    name="mobile_no"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your mobile number!',
                      },
                    ]}
                  >
                    <PhoneInput
                      country={'in'} // Default country (India)
                      enableSearch={true} // Enable searching for countries
                      placeholder="Enter mobile number"
                    />
                  </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
              <Form.Item
                    label="Phone Number"
                    name="phone_no"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your phone number!',
                      },
                    ]}
                  >
                    <PhoneInput
                      country={'in'} // Default country (India)
                      enableSearch={true} // Enable searching for countries
                      placeholder="Enter phone number"
                    />
                  </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
              <Form.Item
                    label="Email"
                    name="email_id"
                    rules={[
                      {
                        type: 'email',
                        message: 'Please enter a valid email address',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Email" />
                  </Form.Item>
                  </Col>
                  <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="send_sms_type"
                    label="Sending Sms Type"
                    rules={[
                      {
                        required: true,
                        message: 'Please select sms type',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Sending Sms Type"
                      onChange={handleSendSmsTypeOptionChange}
                      onSearch={handleSearchSmsTypeDie}
                      showSearch={true}
                      value={selectSendSmsType}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          sendingSmsType.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={12} xl={6} xxl={4}>
                <Form.Item
                  label=""
                  name="is_active"
                  valuePropName="checked"
                >
                  <Checkbox >Is Active</Checkbox>
                </Form.Item>
              </Col> */}
               <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="is_active"
                    label="Is Active"
                    rules={[
                      {
                        required: true,
                        message: 'Please select status',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Is Active"
                      onChange={handleIsActiveOptionChange}
                      onSearch={handleSearchIsActive}
                      showSearch={true}
                      value={selectIsActiveOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          isActiveStatus.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>

           


            </Row>
          </div>
       
          <div className="flex justify-end">
            <Form.Item className="mb-0">
              <Button
                type="primary"
                htmlType="submit"
                loading={btnLoading}
                icon={<PlusOutlined />}
              >
                Add Transporter
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </>
  );
}

export default AddTransporter;
